import styled, { css } from 'styled-components';
import { header4, text1 } from '@ardoq/typography';
import { dashedGrey1, colors, r8, s16, s8 } from '@ardoq/design-tokens';
import { disabledCSS } from '@ardoq/style-helpers';
import { FlexBox } from '@ardoq/layout';
import { FIELD_SELECTOR } from '@ardoq/forms';
import { IconButton } from '@ardoq/button';
export const groupBoxStyle = css`
  ${text1};
  padding: ${s16} ${s8};
  border: ${dashedGrey1};
  border-radius: ${r8};
`;
export const GroupBox = styled(FlexBox).attrs({
  align: 'center',
  gap: 'small',
})`
  ${groupBoxStyle}

  ${FIELD_SELECTOR} {
    flex: 1;
  }
`;

export const RuleWarningContainer = styled.div`
  width: 100%;
  padding: 0 ${s8};
`;

export const RowHeader = styled.div`
  ${header4};
`;

export const HeaderRowWrapper = styled.div`
  display: flex;
  gap: ${s8};
  width: 100%;
  align-items: center;
`;

type InputsWrapperProperties = {
  $isDisabled?: boolean;
};

export const InputsWrapper = styled.div.attrs<InputsWrapperProperties>(
  ({ $isDisabled }) => ({ inert: $isDisabled })
)<InputsWrapperProperties>`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  padding: 0 ${s8};
  gap: ${s8};
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      ${disabledCSS};
      user-select: none;
    `}
`;

export const ViewOptionsClickableIcon = styled(IconButton)`
  color: ${colors.grey500};
`;
